import {
    IAuthResult,
    IConfirmAccount,
    ConfirmAccount,
    CheckAccountConfirmationToken,
    ISendConfirmationEmailAgain,
    SendConfirmationEmailAgain,
    IConfirmEmailByToken,
    ConfirmEmailByToken,
    IChangePassword,
    ChangePassword,
    ISendVerificationCode,
    ICheckVerificationCode,
    IResetPassword,
    ResetPassword,
    CheckVerificationCode,
    SendVerificationCode, LoginAccUser, ILoginAccUser,
} from '../../api/ApiClient';
import { setAuthToken, clearAuthToken } from '_helpers';
import { INotification } from 'components';
import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';

const initialState: AuthState = null;

export default createModel({
    state: initialState as AuthState,
    reducers: {
        setAuth(state, data: IAuthResult) {
            return { ...(state || {}), ...data };
        },
        logout() {
            clearAuthToken();

            return initialState;
        },
    },
    effects: (dispatch: any) => ({
        async login(data: ILoginAccUser) {
            const auth = await apiConnector.execApi(dispatch, apiClient => apiClient.login(new LoginAccUser(data)));

            if (!auth) return;

            setAuthToken(auth.token);
            this.setAuth(auth);
        },
        async fetchProfile() {
            const profile = await apiConnector.execApi(dispatch, apiClient => apiClient.profile());
            this.setAuth({ profile });
        },
        async checkAccountConfirmationTokenAsync(token: string) {
            return apiConnector.execApi(dispatch, apiClient => apiClient.checkAccountConfirmationToken(new CheckAccountConfirmationToken({ token })));
        },
        async confirmAccountAsync(data: IConfirmAccount) {
            const auth = await apiConnector.execApi(dispatch, apiClient => apiClient.confirmAccount(new ConfirmAccount(data)));
            if (!auth) return;

            setAuthToken(auth.token);

            this.setAuth({ profile: auth.profile });
        },
        async sendResetPasswordVerificationCodeAsync(data: ISendVerificationCode) {
            return apiConnector.execApi(dispatch, apiClient => apiClient.sendResetPasswordVerificationCode(new SendVerificationCode(data)));
        },
        async checkResetPasswordVerificationCodeAsync(data: ICheckVerificationCode) {
            return apiConnector.execApi(dispatch, apiClient => apiClient.checkResetPasswordVerificationCode(new CheckVerificationCode(data)));
        },
        async resetPasswordAsync(body: IResetPassword) {
            const res = await apiConnector.execApi(dispatch, apiClient => apiClient.resetPassword(new ResetPassword(body)));

            if (res) {
                setAuthToken(res.token);
                this.setAuth(res);
                dispatch.notifications.addNotification([{ message: 'Пароль успешно изменен!', appearance: 'success' }] as INotification[]);
            }
            return res;
        },
        async sendConfirmationEmailAsync(body: ISendConfirmationEmailAgain) {
            const res = await apiConnector.execApi(dispatch, apiClient => apiClient.sendConfirmationEmailAgain(new SendConfirmationEmailAgain(body)));
            if (res) {
                dispatch.notifications.addNotification([{ message: 'Ссылка для подтверждения электронной почты успешно отправлена!', appearance: 'success' }] as INotification[]);
            }
            return res;
        },
        async confirmEmailByTokenAsync(body: IConfirmEmailByToken) {
            const res = await apiConnector.execApi(dispatch, apiClient => apiClient.confirmEmailByToken(new ConfirmEmailByToken(body)));
            if (res) {
                dispatch.notifications.addNotification([{ message: 'Email успешно подтвержден!', appearance: 'success' }] as INotification[]);
            }
            return res;
        },
        async changePasswordAsync(body: IChangePassword) {
            const res = await apiConnector.execApi(dispatch, apiClient => apiClient.changePassword(new ChangePassword(body)));

            if (res) {
                dispatch.notifications.addNotification([{ message: 'Пароль успешно изменен!', appearance: 'success' }] as INotification[]);
            }
            return res;
        },
    }),
});

type AuthState = IAuthResult | null;
